import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TermsStyled } from '../../../asset/styled/TermsStyled';

import checked_gray_icon from '../../../asset/img/common/checked_gray_icon.svg';
import checked_icon from '../../../asset/img/common/checked_primary_icon.svg';
import arrow_right_icon from '../../../asset/img/common/arrow_right_icon.svg';
import arrow_right_999_icon from '../../../asset/img/common/arrow_right_999_icon.svg';

import Typography from '../../../components/common/Typography';
import CheckBox from '../../../components/common/CheckBox';
import Button from '../../../components/common/Button';
import Description from './Description';
import { checkYaInsaPer, setMobileAgree } from '../../common/commonSlice';
import { getAlertMessageFunction } from '../../../common/Util';
import SlideRightDialog from '../../../components/common/SlideRightDialog';

// 동의하기
const Terms = ({ isSlideOpen, isSlideClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('terms');
  const [isChecked, setIsChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSubChecked, setIsSubChecked] = useState([
    {
      id: 1,
      isChecked: false,
    },
    {
      id: 2,
      isChecked: false,
    },
    {
      id: 3,
      isChecked: false,
    },
  ]);
  const checkBoxList = [
    {
      // 개인정보 등 수집·이용·제공에 관한 동의
      id: 1,
      title: t('terms1.title'),
      description: t('terms1.description'),
    },
    {
      // 고유식별정보의 처리에 관한 동의
      id: 2,
      title: t('terms2.title'),
      description: t('terms2.description'),
    },
    {
      // 소득공제신고서 및 증빙 제출에 따른 본인 신의 성실성 동의 및 월급날 법적 책임 제한의 고지
      id: 3,
      title: t('terms3.title'),
      description: t('terms3.description'),
    },
  ];

  // 모든 하위 체크박스가 체크되었는지 확인
  useEffect(() => {
    const allChecked = isSubChecked.every(item => item.isChecked);
    setIsChecked(allChecked);
  }, [isSubChecked]);

  //동의하기 화면에서 버튼 클릭
  const handleSubCheckboxChange2 = id => {
    const updatedSubChecked = isSubChecked.map(item =>
      item.id === id ? { ...item, isChecked: true } : item,
    );
    setIsSubChecked(updatedSubChecked);
    setIsOpen(false);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = id => {
    setIsOpen(id);
  };

  const title = checkBoxList.find(item => item.id === isOpen)?.title;
  const description = checkBoxList.find(item => item.id === isOpen)?.description;

  return (
    <SlideRightDialog isOpen={isSlideOpen} onClose={isSlideClose} title={t('myInfoTitle')}>
      <TermsStyled isChecked={isChecked}>
        {/* 체크 있는거 개인정보, 고유식별, 소득공제신고~~ */}
        <div className="displayFlexColumn" style={{ gap: '20px' }}>
          {checkBoxList.map(item => (
            <div
              className="displayFlex"
              style={{
                gap: '10px',
                alignItems: item.id === 3 ? 'flex-start' : 'center',
              }}
              onClick={() => onOpen(item.id)}
              key={item.id}>
              {/* <CheckBox
                variant="circle"
                size={'regular'}
                checked={isSubChecked[item.id - 1].isChecked}
                onChange={() => handleSubCheckboxChange(item.id)}
              /> */}
              <Typography
                className="body2Medium"
                style={{
                  flex: 1,
                }}>
                {item.title}
              </Typography>
              <img
                src={arrow_right_icon}
                alt="arrow_right_icon"
                onClick={e => {
                  e.stopPropagation();
                  onOpen(item.id);
                }}
              />
            </div>
          ))}
        </div>

        {/* 약관 별 slide */}
        <Description
          isOpen={isOpen}
          onClose={onClose}
          title={title}
          description={description}
          handleSubCheckboxChange2={handleSubCheckboxChange2}
        />
      </TermsStyled>
    </SlideRightDialog>
  );
};

export default Terms;
